import preloader from '@/components/preloader/index.vue';
import pagination from '@/components/pagination/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import {
  CHANGE_HISTORY_ICON,
  DEFAULT_IMAGE,
} from '@/utils/const';

import Api from '@/utils/api';

export default {
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  components: {
    preloader,
    pagination,
    empty,
  },
  data () {
    return {
      historyData: [],
      responseData: [],
      iconEvent: CHANGE_HISTORY_ICON,
      defaultImage: DEFAULT_IMAGE,
      nameErrorType: {
        'ErrorCategory': 'Category',
        'ErrorSeverity': 'Severity',
        'KOStatus': 'KO error',
        'Metarule': 'Rule(s)',
      },

      query: {
        id: null,
        page: 1,
        perPage: 8,
      },

      load: true,
    };
  },
  created () {
    this.query.id = this.reportId;
    this.getAllHistory();
  },
  methods: {
    /**
         * Get all history information
         */
    getAllHistory () {
      this.load = true;

      Api.reports
        .getHistory(this.query)
        .then((data) => {
          this.historyData = data.data.Data;
          this.responseData = data.data;

          this.load = false;
        });
    },
    sendPage (page) {
      this.query.page = page;
      this.getAllHistory();
    },
  },
};
